import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_e46e40bf-3320-41b9-b27d-8d7b60eb4a9e/artifacts/xp00bckt_statonary%20design%20AAWTA%20Logo_1-100%20%281%29%20%281%29.jpg";

export const EVENTBRITE_URL =
  "https://www.eventbrite.com/e/the-3rd-annual-the-power-to-drive-change-fundraising-gala-atlanta-ga-tickets-1989931654145?aff=ebdsoporgprofile";

export const HILTON_URL =
  "https://www.hilton.com/en/book/reservation/deeplink/?ctyhocn=ATLMAHF&groupCode=90O&arrivaldate=2026-12-09&departuredate=2026-12-11&cid=OM,WW,HILTONLINK,EN,DirectLink&fromId=HILTONLINKDIRECT";

// Live Zeffy / Eventbrite / Google Forms campaign links
export const ZEFFY = {
  // "Become a Sponsor" → AAWTA Memberships ticketing page (year-round sponsorship)
  sponsor: "https://www.zeffy.com/ticketing/aawta-memberships--2025-2",
  // Scholarship & gala sponsorship tier checkout → Gala ticketing page
  scholarship:
    "https://www.zeffy.com/en-US/ticketing/aawta-3rd-annual-power-to-drive-change-fundraising-gala-workforce-leadership-and-industry-impact",
  galaTier:
    "https://www.zeffy.com/en-US/ticketing/aawta-3rd-annual-power-to-drive-change-fundraising-gala-workforce-leadership-and-industry-impact",
  // Strategic Partnership shares the memberships ticketing page
  partnership: "https://www.zeffy.com/ticketing/aawta-memberships--2025-2",
  vipTable:
    "https://www.eventbrite.com/e/the-3rd-annual-the-power-to-drive-change-fundraising-gala-atlanta-ga-tickets-1989931654145?aff=oddtdtcreator&keep_tld=true",
  donate:
    "https://www.zeffy.com/en-US/donation-form/donate-to-the-3rd-annual-power-to-drive-change-fundraising-gala",
  inKind:
    "https://docs.google.com/forms/d/e/1FAIpQLSfGGaliMUuQb56NK6NsCis_WLooLlLqpIscUmY9LUiEdNfs3w/viewform?usp=publish-editor",
};
